"use client";

import styles from "./styles.module.scss";

import {
  BlockHeaderSuperposition,
  CardContainer,
  CardProps,
} from "@/components/templates";
import jobHero from "../../../assets/images/jobs_hero.jpg";
import { MyH2 } from "@/components/atoms";
import { jobsData } from "./data";
import { useRouter } from "next/navigation";
import { useCallback } from "react";

const jobs: CardProps[] = jobsData.map(({ slug, image, title }, id) => ({
  id,
  image,
  slug,
  alt: title,
  children: () => {
    return (
      <div className={styles.card_content}>
        <MyH2>{title}</MyH2>
        {/* <div className={styles.paragraphs}>
          {(texts || []).map((el) => (
            <p key={uniqid()}>{el}</p>
          ))}
        </div>
        <div className={styles.btn_container}>
          <MyButton label="Découvrir" />
        </div> */}
      </div>
    );
  },
}));

export const Jobs = () => {
  const router = useRouter();

  return (
    <>
      <BlockHeaderSuperposition
        title="L’humain au centre "
        image={jobHero}
        textInWhiteBlock={
          /* html */ `<p>Nous construisons avec soin et intention. En tant que groupe de créateurs, nous encourageons notre équipe à trouver un équilibre entre travail et vie personnel.</p><p> Les expériences, l'épanouissement et l'intérêt pour le monde extérieur à l'espace de travail inspirent la créativité, la croissance et la collaboration dans l'espace de travail.</p>`
        }
        btnlabel="Contact"
        breadCrumbProps={{
          data: [
            {
              url: "/",
              label: "Accueil",
            },
            {
              url: "/jobs",
              label: "Jobs",
            },
          ],
        }}
        onClickBtn={() => router.push("/contact")}
      />
      <div className={styles.contents}>
        <MyH2 className={styles.h2}>Découvrir nos profils</MyH2>
        <p>
          Notre culture permet une véritable collaboration, un équilibre
          travail-vie personnelle et la possibilité pour les personnes
          talentueuses de faire de leur mieux.
        </p>
      </div>
      <div className={styles.card_container}>
        <CardContainer root="/jobs" data={jobs} />
      </div>
    </>
  );
};
